import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false // NOSONAR
})
export class UnauthorizedComponent implements OnInit {
  constructor(
  ) {}

  ngOnInit(): void {
    console.info('')
  }
}